<template>
  <div>
    <div v-if="card.category" class="card-header">
      <span>{{ card.category }}</span>
    </div>
    <div v-if="card.thumb" class="card-img-wrapper" :class="{'no-category': !card.category}">
        <a :href="card.links[0].url">
          <div class='card-img' :class="decideClass(card.thumb)" :style="{ 'background-image': 'url(' + card.thumb + ')' }" />
        </a>
    </div>
    <div class="card-title">
      <a :href="card.links[0].url">
        <h3 v-html="card.title"></h3>
      </a>
    </div>
    <div v-if="card.date" class="card-date">
      <p>{{ card.date }}</p>
    </div>
    <div v-if="card.doc_name" class="card-details">
      <p>{{card.doc_name}}</p>
    </div>
    <div v-if="card.authors" class="card-details">
      <p>{{card.authors}}</p>
    </div>
    <div v-if="card.source" class="card-details">
      <p v-html="card.source"></p>
    </div>
    <div class="card-links">
      <div class="link-content">
        <a 
          v-for="(item, index) of card.links"
          :key="index"
          :href="item.url"
          :target="item.target"
          class="nav-item"
        >{{ item.prompt }}</a>
      </div>
    </div>
    <div v-if="card.side_header && card.thumb" class="card-side-header">
      <div class="inner">{{card.side_header}}</div>
    </div>
  </div>
</template>

<style lang="scss">
.card-img-wrapper {
  .iconic {
    background-size: 90%;
    background-color: rgba($quaternary-color, 0.3);
  }
}

.card-side-header {
  position: absolute;
  writing-mode: tb-rl;
  transform: rotate(-180deg);
  height: 430px;
  text-align: center;
  text-transform: uppercase;
  font-size: 16pt;
  left: 0;

  .inner {
    background: rgb($quaternary-color);
    color: rgb($secondary-color);
    display: inline-block;
    height: 200px;
    padding: 0 0.3rem;
  }
}

@media (max-width: 767.98px) {
  .card-side-header {
    height: 100%;
    max-height: 500px;
    .inner {
      height: unset;
      padding: 1rem 0.3rem;
    }
  }

}
</style>

<script>
export default {
  name: "fcwpArchiveCard",
  props: ["card"],
  methods: {
    decideClass(filename) {
      var last_dot = filename.lastIndexOf('.') + 1;
      var extension = filename.substr(last_dot);
      if (extension == 'png' || extension == 'gif') return 'iconic';
      return null;
    }
  }
};
</script>